import { Location } from '@angular/common';
import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  inject,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { UserUnifiedFacade } from '@thiememeulenhoff/ng-store';
import { catchError, EMPTY, tap } from 'rxjs';
import { AuthenticationService } from '../../services';
import { AdminHeaderComponent } from '../admin-header/admin-header.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'edu-admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [AdminHeaderComponent, RouterOutlet],
})
export class AdminLayoutComponent implements OnInit {
  readonly #authService = inject(AuthenticationService);

  readonly #userUnified = inject(UserUnifiedFacade);

  readonly #location = inject(Location);

  readonly #router = inject(Router);

  ngOnInit(): void {
    this.#authService
      .login()
      .pipe(
        tap(() => this.#userUnified.initialize()),
        catchError(() => {
          return EMPTY;
        }),
      )
      .subscribe();
  }

  goBack(): void {
    if (window.history.length > 1) {
      this.#location.back();
      return;
    }

    this.#router.navigateByUrl('/');
  }
}
